import type { ReactNode, HTMLAttributes } from 'react';

type CardProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
  hoverable?: boolean;
  padded?: boolean;
};

export default function Card({
  children,
  hoverable = false,
  padded = false,
  className = '',
  ...rest
}: CardProps) {
  const hover = hoverable
    ? 'transition-all duration-150 hover:shadow-card-md hover:-translate-y-px'
    : '';
  const pad = padded ? 'p-6' : '';
  return (
    <div
      className={`bg-cream-50 rounded-card shadow-card-sm ${hover} ${pad} ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}
